import React from 'react';
import PropTypes from 'prop-types';
import Field from 'redux-form/es/Field';
import cx from 'classnames';
import InputRangeSlider from 'components/Credit24/Core/Controls/InputRangeSlider';
import { inputRangeClassNames } from 'consts';

const rangeInput = (props) => {
  const {
    input,
    step,
    minValue,
    maxValue,
    defaultVal,
    classNames,
    theme,
    productType,
    availablePrincipalsIndex,
    warning,
    showMaxValue,
    alignLeft,
    asterisk,
  } = props;
  return (
    <InputRangeSlider
      {...input}
      name={props.input.name}
      maxValue={maxValue}
      minValue={minValue}
      step={step}
      defaultValue={defaultVal}
      classNames={classNames}
      theme={theme}
      updateOnRender
      productType={productType}
      availablePrincipalsIndex={availablePrincipalsIndex}
      warning={warning}
      showMaxValue={showMaxValue}
      alignLeft={alignLeft}
      asterisk={asterisk}
    />
  );
};

rangeInput.propTypes = {
  input: PropTypes.object,
  classNames: PropTypes.object,
  step: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  defaultVal: PropTypes.number,
  productType: PropTypes.string,
  theme: PropTypes.string,
  availablePrincipalsIndex: PropTypes.array,
  warning: PropTypes.bool,
  showMaxValue: PropTypes.bool,
  alignLeft: PropTypes.bool,
  asterisk: PropTypes.bool,
};

rangeInput.defaultProps = {
  asterisk: false,
};

const Slider = ({
  maxValue,
  minValue,
  defaultValue,
  step,
  name,
  availablePrincipalsIndex,
  productType,
  theme,
  warning,
  showMaxValue,
  alignLeft,
  asterisk,
}) => {
  const classNames = { ...inputRangeClassNames };
  classNames.inputRange = cx({
    'input-range': true,
    [`input-range--theme-${theme}`]: theme,
  });
  return (
    <Field
      name={name}
      type="text"
      maxValue={maxValue}
      minValue={minValue}
      defaultVal={defaultValue}
      step={step}
      component={rangeInput}
      classNames={classNames}
      theme={theme}
      productType={productType}
      availablePrincipalsIndex={availablePrincipalsIndex}
      warning={warning}
      showMaxValue={showMaxValue}
      alignLeft={alignLeft}
      asterisk={asterisk}
    />
  );
};

Slider.propTypes = {
  maxValue: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  defaultValue: PropTypes.number,
  step: PropTypes.number.isRequired,
  productType: PropTypes.string,
  name: PropTypes.string,
  availablePrincipalsIndex: PropTypes.array,
  theme: PropTypes.string,
  warning: PropTypes.bool,
  showMaxValue: PropTypes.bool,
  alignLeft: PropTypes.bool,
  asterisk: PropTypes.bool,
};

Slider.defaultProps = {
  alignLeft: true,
};

export default Slider;
